export default __webpack_public_path__ + "static/media/slider-cerini.5379986a.jpg";